import { render } from "./PopupModal.vue?vue&type=template&id=0f521a08&scoped=true"
import script from "./PopupModal.vue?vue&type=script&lang=ts"
export * from "./PopupModal.vue?vue&type=script&lang=ts"

import "./PopupModal.vue?vue&type=style&index=0&id=0f521a08&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0f521a08"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QForm,QInput,QSeparator,QAvatar,QFile,QSpace});
